"use strict";import{tag as l}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const AlignLeftIcon=({width:t=24,height:e=24,hidden:r=!1,title:i="Align Left"}={})=>l`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${e}"
    viewBox="0 0 36 36"
    width="${t}"
    aria-hidden=${r?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${i}"
  >
    <rect height="36" rx=".5" ry=".5" width="2" x="2" />
    <rect height="10" rx="1" ry="1" width="26" x="6" y="20" />
    <rect height="10" rx="1" ry="1" width="16" x="6" y="6" />
  </svg>`;
//# sourceMappingURL=AlignLeft.js.map
